<template>
  <div class="search-item">
    <span class="label">{{ item.label || item.key }}</span>
    <div>
      <el-autocomplete
        v-if="item.type === 'complete'"
        v-model="item.val"
        :fetch-suggestions="querySearch"
        size="mini"
        placeholder="搜索关键词"
      />
      <el-select
        v-else-if="item.options"
        v-model="item.val"
        :multiple="item.multiple"
        filterable
        clearable
        size="mini"
        placeholder="选择"
        @focus="onFocus"
        @change="item.label === '职能模块' && onChangeCategory(items, item)"
      >
        <el-option
          v-for="(option, index) in item.options"
          :key="index"
          :value="option.value || option"
          :label="option.label || option"
        />
      </el-select>
      <el-date-picker
        v-else-if="item.type === 'daterange'"
        v-model="item.val"
        type="daterange"
        size="mini"
        value-format="timestamp"
        start-placeholder="起始时间"
        end-placeholder="结束时间"
        range-separator="~"
      />
      <el-input v-else v-model="item.val" :placeholder="item.placeholder" clearable size="mini" />
    </div>
  </div>
</template>

<script>
import { onChangeCategory, uniqueElementsBy } from '../constant/utils'

export default {
  props: {
    items: { type: Array, default: undefined },
    item: { type: Object, default: undefined },
  },
  computed: {
    onChangeCategory() {
      return onChangeCategory
    },
  },
  created() {
    this.loaded = {}
  },
  methods: {
    async querySearch(queryString, cb) {
      const item = this.item
      if (item.remote === 'projects') {
        await this.searchProjects(queryString, cb)
        return
      }
      if (!this.loaded.users && item.remote === 'users') {
        await this.getUsers()
      }
      const options = item.options || []
      const results = queryString
        ? options.filter(val => val.label && val.label.toLowerCase().includes(queryString.toLowerCase()))
        : options
      cb(results)
    },
    onFocus() {
      if (!this.initCategoryOptions && this.item.label === '职能模块') {
        this.getCategories()
      } else if (this.item.remote === 'users') {
        this.item.options = app.accounts
      }
    },
    async getCategories() {
      try {
        if (!this.categories) {
          this.categories = await app.service('project').simpleCategories()
        }
        this.item.options = (this.categories || []).map((val, index) => ({
          label: val.名称,
          value: val.名称,
          细分职能: val['二级职能'],
          擅长方向: val['擅长方向'],
        }))
        this.initCategoryOptions = true
      } catch (e) {
        console.error(e)
      }
    },
    async getUsers() {
      try {
        const res = await app.service('project').simpleUsers()
        this.item.options = res.map((val, index) => ({
          label: val.account,
          value: val.account,
        }))
        this.loaded.users = true
      } catch (e) {
        console.error(e)
      }
    },
    async searchProjects(queryString, cb) {
      if (!queryString) return cb([])
      try {
        const { data } = await app.service('project').search({
          keywords: queryString,
          type: '项目',
        })
        if (!data || data.length === 0) return cb([])
        const results = []
        const existProjectName = {}
        data.forEach(project => {
          const name = project['项目名称']
          if (!existProjectName[name]) {
            results.push({
              label: name,
              value: name,
            })
            existProjectName[name] = true
          }
        })
        cb(results)
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>

<style scoped>
.search-item {
  display: -ms-flexbox;
  display: inline-flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 5px;
}
.label {
  line-height: 28px;
  margin: 0 5px 0 0;
}

.el-select__tags {
  width: auto;
}
.input-field .el-date-editor--daterange {
  max-width: 280px;
}
</style>
